import { jsonPost, deleteJson, commonThinxHeaders } from 'api'

export const createVehicle = (accountKey, token, tag, make, model, color, country, state, businessAccount) =>
    jsonPost(
        `${THINX_BASE_VEHICLE_URL}/vehicle/${accountKey}`,
        {
            inactive: false,
            fieldMap: {
                color: {
                    inactive: false,
                    value: color.toUpperCase(),
                },
                model: {
                    inactive: false,
                    value: model.toUpperCase(),
                },
                plateNumber: {
                    inactive: false,
                    value: tag.toUpperCase(),
                },
                make: {
                    inactive: false,
                    value: make.toUpperCase(),
                },
                country: {
                    code: 'country',
                    inactive: false,
                    value: country.toUpperCase(),
                },
                stateRegistered: {
                    inactive: false,
                    value: state.toUpperCase(),
                    code: 'stateRegistered',
                },
                propagate: {
                    value: !businessAccount,
                },
            },
        },
        commonThinxHeaders(token, false, { 'Content-Type': 'text/plain' })
    ).catch(error => {
        throw new Error(error.message)
    })

export const removeVehicle = (accountKey, token, vehicleId, propagate) =>
    deleteJson(
        `${THINX_BASE_VEHICLE_URL}/vehicle/${accountKey}`,
        {
            vehicleId,
            propagate,
        },
        commonThinxHeaders(token)
    ).catch(error => {
        throw new Error(error.message)
    })
